import _Star from '@lyearn/icons/dist/cjs/web/Star';
import _StarOutline from '@lyearn/icons/dist/cjs/web/StarOutline';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default from 'react';
import BaseRating from '@mui/material/Rating';
import { CLASSES } from './styles.js';

var _excluded = ["size"];
var StarRating = function StarRating(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 36 : _props$size,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React__default.createElement(BaseRating, _extends({
    classes: CLASSES,
    emptyIcon: /*#__PURE__*/React__default.createElement(_StarOutline, {
      fillColorToken: "icon-secondary",
      height: size,
      width: size
    }),
    icon: /*#__PURE__*/React__default.createElement(_Star, {
      fillColorToken: "icon-warning-light",
      height: size,
      width: size
    })
  }, rest));
};
var index = /*#__PURE__*/React__default.memo(StarRating);

export { index as default };
//# sourceMappingURL=index.js.map
